export enum AspectsToneEnum {
    Negative = 'negative',
    Neutral = 'neutral',
    Positive = 'positive',
}
